import ExtendedPropertyType from 'owa-service/lib/contract/ExtendedPropertyType';
import ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';

export default function getExtendedPropertyFromItem(
    item: ClientItem,
    propertyName: string
): ExtendedPropertyType | null {
    const extendedProperties = item.ExtendedProperty;
    if (extendedProperties) {
        const numProperties = extendedProperties.length;
        for (let i = 0; i < numProperties; i++) {
            const prop = extendedProperties[i];
            if (prop?.ExtendedFieldURI?.PropertyName === propertyName) {
                return prop;
            }
        }
    }
    return null;
}
